document.addEventListener('click', function(e) {
  if(e.target.parentNode.matches('.clickable') || e.target.matches('.expand-icon')) {
    $(".expand-icon").toggleClass('rotate');
    $(".non-total").fadeToggle();
  }
});
